import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { IApplication } from '../../types';
import ApplicationSummarySection from './ApplicationSummarySection';
import EligibilityResultsSection from './EligibilityResultsSection';
import HouseholdMembersSection from './HouseholdMembersSection';

interface IHistoricalApplicationsContentProps {
    applications: IApplication[];
}

const HistoricalApplicationsContent: React.FC<IHistoricalApplicationsContentProps> = ({ applications }) => {
    
    return (
        <>
            <ConditionalRendering isTrue={applications.length === 0}>
                <div className="text-center padding-y-5 text-base-dark">
                    <FormattedMessage id="historical.member.applications.noApplicationDataAvailable" />
                </div>
            </ConditionalRendering>

            <ConditionalRendering isTrue={applications.length > 0}>
                {applications.map((application, index) => (
                    <div
                        key={application.applicationId || index}
                        className="border-1px border-base-lighter radius-lg padding-3 margin-bottom-3"
                    >
                        <ApplicationSummarySection application={application} />
                        <EligibilityResultsSection
                            applicants={application.applicants}
                        />
                        <HouseholdMembersSection application={application} />
                    </div>
                ))}
            </ConditionalRendering>
        </>
    );
};

export default HistoricalApplicationsContent;
